module.exports = __webpack_public_path__ + "img/ly.592a5116.svg";